import { isHosted } from "owa-config/lib/isHosted";
import { ThemeConstants } from "owa-theme-shared";
import { isTenantThemeDataAvailable } from "./isTenantThemeDataAvailable";
import { isOrganizationThemeForced, shouldIgnoreOrganizationThemePolicy, } from "./isUserPersonalizationAllowed";

/**
 * Resolves the theme under organization policy: forced branding in OWA and in Monarch without
 * Win32 styling, or Outlook/Neutral in Monarch with Win32 styling. Preserves hosted and contrast themes.
 */
export function getThemeIdForOrganizationPolicy(themeId: string): string {
    // Hosted apps keep their host-provided theme; preserve the accessibility contrast theme.
    if (isHosted() || themeId === ThemeConstants.CONTRAST_THEME_ID) {
        return themeId;
    }
    
    if (isOrganizationThemeForced()) {
        return ThemeConstants.BASE_THEME_ID;
    }
    
    if (shouldIgnoreOrganizationThemePolicy()) {
        const outlookThemeId = isTenantThemeDataAvailable()
            ? ThemeConstants.BASE_OFFICE_THEME_ID
            : ThemeConstants.BASE_THEME_ID;
        return themeId === outlookThemeId
            ? outlookThemeId
            : ThemeConstants.MODERN_OFFICE_NEUTRAL_THEME_ID;
    }
    
    return themeId;
}
